import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/headerlink.css';

const HeaderLink = ({ num, name, url, buildLinkURL, lang }) => {
  const [linkIsActive, setLinkIsActive] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLinkIsActive(location.pathname.includes(url));
  }, [location, url]);

  return (
    <div>
      {num % 2 === 0 ? (
        <div>
          <div className={linkIsActive ? 'el-nav-object link-active' : 'el-nav-object'}>
            <Link to={buildLinkURL(url)} className='el-nav-url'>
              <div className='el-nav-space'>
                {name}
              </div>
            </Link>
          </div>
          <div className='el-space-object'></div>
        </div>
      ) : (
        <div>
          <div className='el-space-object'></div>
          <div className={linkIsActive ? 'el-nav-object link-active' : 'el-nav-object'}>
            <Link to={buildLinkURL(url)} className='el-nav-url'>
              <div className='el-nav-space'>
                {name}
              </div>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderLink;
